import React from "react";
import Modal from "../../component/Inc/Modal";
function PopPrice(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="pop_price">
      <h2 className="pop_tit">조정 금액</h2>
      <div className="content_container scroll">
        <div className="com_info">
          <p className="name">서울 제일 총판</p>
          <p className="date dot">김대표(02-1234-3214)</p>
        </div>
        <table className="com_board_list type_bg_blue">
          <colgroup>
            <col width="15%" />
            <col width="15%" />
            <col width="20%" />
            <col width="20%" />
            <col width="30%" />
          </colgroup>
          <thead>
            <tr>
              <th>조정일</th>
              <th>조정자</th>
              <th>기존 잔액</th>
              <th>조정 금액</th>
              <th>사유</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_point">+ 40,000</td>
              <td></td>
            </tr>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_red">- 560,000</td>
              <td></td>
            </tr>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_point">+ 40,000</td>
              <td></td>
            </tr>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_point">+ 40,000</td>
              <td></td>
            </tr>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_point">+ 40,000</td>
              <td></td>
            </tr>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_point">+ 40,000</td>
              <td></td>
            </tr>
            <tr>
              <td>2023, 05, 10</td>
              <td>김관리103</td>
              <td>450,000</td>
              <td className="td_point">+ 40,000</td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div className="info_box">
          <div className="info">
            <p className="tit">기존 잔액 </p>
            <p className="name">450,000</p>
          </div>
          <div className="info">
            <p className="tit">조정 금액</p>
            <div className="amount_adjust">
              <button className="btn_add_gray" />
              <button className="btn_add_gray" />
              <input
                type="text"
                className="input red_txt"
                placeholder="조정할 금액 입력"
              />
            </div>
          </div>
          <div className="info ">
            <p className="tit">사유</p>

            <input type="text" className="input" defaultValue={`사유 입력`} />
          </div>
        </div>
      </div>

      <div className="btn_container">
        <button className="com_btn orange xs">등록</button>
      </div>
    </Modal>
  );
}

export default PopPrice;
